import { useMemo } from 'react';
import { imageBasePath } from 'constants';
import useRoleplayHelper from 'features/realplays/RealPlay.helper';
import classes from './RealPlayHeader.module.scss';
import { InputSelect } from 'shared_ui_components';
import useUpdateRealPlaySessionStatusMutation from 'features/realplays/services/mutations/useUpdateRealplaySessionStatus';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const RealPlayHeader = () => {
  const { navigate, PATHS } = useRoleplayHelper();

  const {
    assignment_uuid,
    scenarios,
    selectedScenario,
    sessionInfoTemp,
    session_uuid,
    title,
    isRecording,
    scenario_uuid,
    videoURL,
    tempVideoUrl,
    setScenarioWithSelector,
    setSessionInfoTemp,
    reset,
  } = RealPlayRecordDataHelper();

  const { mutate: updateSession, isLoading: isUpdateSesion } =
    useUpdateRealPlaySessionStatusMutation();

  // List of scenarios for the selector
  const options = useMemo(() => {
    if (!scenarios || scenarios?.length === 0) return [];
    return scenarios?.map((sc, i) => ({
      label: `${i + 1}. ${sc?.name}`,
      value: sc?.uuid,
    }));
  }, [scenarios]);

  const scenariosLength = useMemo(() => scenarios?.length || 0, [scenarios]);

  const value = useMemo(() => {
    return (options ?? []).find((opt) => opt?.value === selectedScenario?.uuid);
  }, [options, selectedScenario]);

  const onSelectedValue = (value) => {
    endSession();
    const newList = {
      ...(scenarios ?? []).find((sce) => sce?.uuid === value),
      isRecording: false,
      tempVideoUrl: '',
    };
    setScenarioWithSelector(newList || {});
    setSessionInfoTemp({});
  };

  const endSession = () => {
    if (!sessionInfoTemp || Object.keys(sessionInfoTemp)?.length === 0) return;
    if (
      !isRecording &&
      session_uuid !== '' &&
      tempVideoUrl !== '' &&
      (videoURL === null || videoURL === '')
    ) {
      console.log('cancel');
      updateSession({ assignment_uuid, scenario_uuid, session_uuid, body: { status: 'CANCELED' } });
    }
  };

  const onClickReturn = () => {
    navigate(PATHS.ROLEPLAYS);
    reset();
  };

  return (
    <div className={classes.header}>
      <button onClick={() => onClickReturn()}>
        <img src={imageBasePath + 'back_arrow.svg'} alt="Return" />
      </button>
      <span className="heading4">{title}</span>
      <div className={classes.right}>
        {scenariosLength > 1 && (
          <div className={classes.scenarioSelector}>
            <InputSelect
              value={value}
              onChange={(opt) => onSelectedValue(opt?.value || '')}
              options={options}
              closeMenuOnSelect
              disabled={isRecording}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RealPlayHeader;
